const routes = [
  {
    path: '/',
    component: () => import('layouts/publico/MasterPublico.vue')
  },
  {
    name: 'relatorioHtml',
    path: '/privado/relatorios/relatorioHtml',
    component: () => import('pages/privado/relatorios/RelatorioHtml.vue')
  },
  {
    path: '/privado',
    component: () => import('layouts/privado/MasterPrivado.vue'),
    children: [
      {
        name: 'index',
        path: 'index',
        component: () => import('pages/Index.vue')
        // beforeEnter: requireAuth
      },
      {
        name: 'orgaoPesquisa',
        path: 'orgao/pesquisa',
        component: () => import('pages/privado/orgao/OrgaoPesquisa.vue')
      },
      {
        name: 'orgao',
        path: 'orgao/cadastrar',
        component: () => import('pages/privado/orgao/Orgao.vue')
      },
      {
        name: 'unidadePesquisa',
        path: 'unidade/pesquisa',
        component: () => import('pages/privado/unidade/UnidadePesquisa.vue')
      },
      {
        name: 'unidade',
        path: 'unidade/cadastrar',
        component: () => import('pages/privado/unidade/Unidade.vue')
      },
      {
        name: 'tipoProcessoPesquisa',
        path: 'tipoDeProcesso/pesquisa',
        component: () => import('pages/privado/tipodeprocesso/TipoDeProcessoPesquisa.vue')
      },
      {
        name: 'tipoDeProcesso',
        path: 'tipoDeProcesso/cadastrar',
        component: () => import('pages/privado/tipodeprocesso/TipoDeProcesso.vue')
      },
      {
        name: 'documentacaoNecessariaPesquisa',
        path: 'documentacaonecessaria/pesquisa',
        component: () => import('pages/privado/documentacaonecessaria/DocumentacaoNecessariaPesquisa.vue')
      },
      {
        name: 'documentacaoNecessaria',
        path: 'documentacaonecessaria/cadastrar',
        component: () => import('pages/privado/documentacaonecessaria/DocumentacaoNecessaria.vue')
      },
      {
        name: 'setorPesquisa',
        path: 'setor/pesquisa',
        component: () => import('pages/privado/setor/SetorPesquisa.vue')
      },
      {
        name: 'setor',
        path: 'setor/cadastrar',
        component: () => import('pages/privado/setor/Setor.vue') },
      {
        name: 'responsavelSetorPesquisa',
        path: 'responsavelSetor/pesquisa',
        component: () => import('pages/privado/responsavelsetor/ResponsavelSetorPesquisa.vue')
      },
      {
        name: 'responsavelSetor',
        path: 'responsavelSetor/cadastrar',
        component: () => import('pages/privado/responsavelsetor/ResponsavelSetor.vue')
      },

      {
        name: 'justificativaPesquisa',
        path: 'justificativa/pesquisa',
        component: () => import('pages/privado/justificativa/JustificativaPesquisa.vue')
      },
      {
        name: 'justificativa',
        path: 'justificativa/cadastrar',
        component: () => import('pages/privado/justificativa/Justificativa.vue')
      },
      {
        name: 'assuntoPesquisa',
        path: 'assunto/pesquisa',
        component: () => import('pages/privado/assunto/AssuntoPesquisa.vue')
      },
      {
        name: 'assunto',
        path: 'assunto/cadastrar',
        component: () => import('pages/privado/assunto/Assunto.vue')
      },
      {
        name: 'SubAssuntoPesquisa',
        path: 'subAssunto/pesquisa',
        component: () => import('pages/privado/subassunto/SubAssuntoPesquisa.vue')
      },
      {
        name: 'subAssunto',
        path: 'subAssunto/cadastrar',
        component: () => import('pages/privado/subassunto/SubAssunto.vue')
      },
      {
        name: 'situacaoPesquisa',
        path: 'situacao/pesquisa',
        component: () => import('pages/privado/situacao/SituacaoPesquisa.vue')
      },
      {
        name: 'documentoPesquisa',
        path: 'documento/pesquisa',
        component: () => import('pages/privado/documento/DocumentoPesquisa.vue')
      },
      {
        name: 'documento',
        path: 'documento/cadastrar',
        component: () => import('pages/privado/documento/Documento.vue')
      },
      {
        name: 'formaSolicitacaoPesquisa',
        path: 'formaSolicitacao/pesquisa',
        component: () => import('pages/privado/formaSolicitacao/FormaSolicitacaoPesquisa.vue')
      },
      {
        name: 'formaSolicitacao',
        path: 'formaSolicitacao/cadastrar',
        component: () => import('pages/privado/formaSolicitacao/FormaSolicitacao.vue')
      },
      {
        name: 'situacao',
        path: 'situacao/cadastrar',
        component: () => import('pages/privado/situacao/Situacao.vue')
      },
      {
        name: 'requerentePesquisa',
        path: 'requerente/pesquisa',
        component: () => import('pages/privado/requerente/RequerentePesquisa.vue')
      },
      {
        name: 'requerente',
        path: 'requerente/cadastrar',
        component: () => import('pages/privado/requerente/Requerente.vue')
      },
      {
        name: 'localizacaoPesquisa',
        path: 'localizacao/pesquisa',
        component: () => import('pages/privado/localizacao/LocalizacaoPesquisa.vue')
      },
      {
        name: 'localizacao',
        path: 'localizacao/cadastrar',
        component: () => import('pages/privado/localizacao/Localizacao.vue')
      },

      {
        name: 'roteiroPesquisa',
        path: 'roteiro/pesquisa',
        component: () => import('pages/privado/roteiro/RoteiroPesquisa.vue')
      },
      {
        name: 'roteiro',
        path: 'roteiro/cadastrar',
        component: () => import('pages/privado/roteiro/Roteiro.vue')
      },
      {
        name: 'solicitacaoAberturaPesquisa',
        path: 'gestaoSolicitacaoAbertura/pesquisa',
        component: () => import('pages/privado/gestaoSolicitacaoAbertura/SolicitacaoAberturaPesquisa.vue')
      },
      {
        name: 'solicitacaoAbertura',
        path: 'gestaoSolicitacaoAbertura/cadastrar',
        component: () => import('pages/privado/gestaoSolicitacaoAbertura/SolicitacaoAbertura.vue')
      },
      {
        name: 'solicitacaoAberturaHistorico',
        path: 'gestaoSolicitacaoAbertura/visualizar',
        component: () => import('pages/privado/gestaoSolicitacaoAbertura/SolicitacaoAberturaHistorico.vue')
      },
      {
        name: 'aberturaProcessoPesquisa',
        path: 'gestaoProcesso/pesquisa',
        component: () => import('pages/privado/gestaoProcesso/AberturaProcessoPesquisa.vue')
      },
      {
        name: 'aberturaProcesso',
        path: 'gestaoProcesso/cadastrar',
        component: () => import('pages/privado/gestaoProcesso/AberturaProcesso.vue')
      },
      {
        name: 'movimentacaoProcesso',
        path: 'gestaoProcesso/movimentacaoProcesso/cadastrar',
        component: () => import('pages/privado/gestaoProcesso/MovimentacaoProcesso.vue')
      },
      {
        name: 'confirmacaoMovimentacaoProcesso',
        path: 'gestaoProcesso/confirmacaoMovimentacaoProcesso/cadastrar',
        component: () => import('pages/privado/gestaoProcesso/ConfirmacaoMovimentacaoProcesso.vue')
      },
      {
        name: 'encerramentoMovimentacaoProcesso',
        path: 'gestaoProcesso/EncerramentoMovimentacaoProcesso/cadastrar',
        component: () => import('pages/privado/gestaoProcesso/EncerramentoMovimentacaoProcesso.vue')
      },
      {
        name: 'cancelarProcesso',
        path: 'gestaoProcesso/cancelarProcesso/cadastrar',
        component: () => import('pages/privado/gestaoProcesso/CancelamentoProcesso.vue')
      },
      {
        name: 'arquivarProcesso',
        path: 'gestaoProcesso/arquivamentoProcesso/cadastrar',
        component: () => import('pages/privado/gestaoProcesso/ArquivamentoProcesso.vue')
      },
      {
        name: 'documentoAnexoProcesso',
        path: 'gestaoProcesso/DocumentoAnexoProcesso/cadastrar',
        component: () => import('pages/privado/gestaoProcesso/DocumentoAnexoProcesso.vue')
      },
      {
        name: 'pendenciaProcesso',
        path: 'pendenciaProcesso/cadastrar',
        component: () => import('pages/privado/gestaoProcesso/PendenciaProcesso.vue')
      },
      {
        name: 'remessaProcessoPesquisa',
        path: 'gestaoRemessa/pesquisa',
        component: () => import('pages/privado/gestaoRemessa/RemessaProcessoPesquisa.vue')
      },
      {
        name: 'remessaProcesso',
        path: 'gestaoRemessa/cadastrar',
        component: () => import('pages/privado/gestaoRemessa/RemessaProcesso.vue')
      },
      {
        name: 'remessaProcessoConfirmacao',
        path: 'gestaoRemessa/RemessaProcessoConfirmacao/cadastrar',
        component: () => import('pages/privado/gestaoRemessa/RemessaProcessoConfirmacao.vue')
      },
      {
        name: 'alteracaoSituacaoProcesso',
        path: 'gestaoProcesso/alteracaoSituacaoProcesso/cadastrar',
        component: () => import('pages/privado/gestaoProcesso/AlteracaoSituacaoProcesso.vue')
      },
      {
        name: 'parametrosSistema',
        path: 'parametrosSistema/cadastrar',
        component: () => import('pages/privado/parametrosSistema/ParametrosSistema.vue')
      },
      {
        name: 'observacaoGeralProcesso',
        path: 'gestaoProcesso/observacaoGeralProcesso/cadastrar',
        component: () => import('pages/privado/gestaoProcesso/ObservacaoGeralProcesso.vue')
      },
      {
        name: 'juncaoProcessoPesquisa',
        path: 'juncaoProcesso/pesquisa',
        component: () => import('pages/privado/juncaoProcesso/JuncaoProcessoPesquisa.vue')
      },
      {
        name: 'juncaoProcesso',
        path: 'juncaoProcesso/cadastrar',
        component: () => import('pages/privado/juncaoProcesso/JuncaoProcesso.vue')
      },
      {
        name: 'juncaoProcessoVisualizar',
        path: 'juncaoProcesso/visualiza',
        component: () => import('pages/privado/juncaoProcesso/JuncaoProcessoVisualizar.vue')
      },
      {
        name: 'aberturaProcessoVisualizar',
        path: 'gestaoProcesso/visualizar',
        component: () => import('pages/privado/gestaoProcesso/AberturaProcessoVisualizar.vue')
      },
      {
        name: 'movimentacaoProcessoVisualizar',
        path: 'movimentacaoProcesso/visualizar',
        component: () => import('pages/privado/gestaoProcesso/MovimentacaoProcessoVisualizar.vue')
      },
      // relatorios
      {
        name: 'Relatorios',
        path: 'Relatorios',
        component: () => import('pages/privado/relatorios/Relatorios.vue')
      },
      {
        name: 'relatorioPdf',
        path: 'relatorios/relatorioPdf',
        component: () => import('./../pages/privado/relatorios/RelatorioPdf.vue')
      },
      {
        name: 'emissaoEtiquetas',
        path: 'emissao/etiqueta',
        component: () => import('pages/privado/emissao/etiqueta/emissaoEtiqueta.vue')
      }
    ]
  }
]

// Always leave this as last one
if (process.env.MODE !== 'ssr') {
  routes.push({
    path: '*',
    component: () => import('pages/Error404.vue')
  })
}

export default routes
